/* eslint-disable @typescript-eslint/explicit-function-return-type */
import gql from "graphql-tag";

export const ImageFilePartsFragmentDoc = /*#__PURE__*/ gql`
  fragment ImageFileParts on FileField {
    __typename
    id
    jpeg: url(imgixParams: { fm: jpg, q: 100 })
    alt
    blurhash
    title
    width
    height
    focalPoint {
      x
      y
    }
  }
`;
export const TextblockModelContentFieldPartsFragmentDoc = /*#__PURE__*/ gql`
  fragment TextblockModelContentFieldParts on TextblockModelContentField {
    blocks
    links
    value
  }
`;
export const ActionButtonRecordPartsFragmentDoc = /*#__PURE__*/ gql`
  fragment ActionButtonRecordParts on ActionButtonRecord {
    __typename
    id
    link
    text
  }
`;
export const TextBlockPartsFragmentDoc = /*#__PURE__*/ gql`
  fragment TextBlockParts on TextblockRecord {
    icon
    title
    introtext
    headingunderlinecolor
    content {
      ...TextblockModelContentFieldParts
    }
    actionbutton {
      ...ActionButtonRecordParts
    }
  }
  ${TextblockModelContentFieldPartsFragmentDoc}
  ${ActionButtonRecordPartsFragmentDoc}
`;
export const DefaultHeaderPartsFragmentDoc = /*#__PURE__*/ gql`
  fragment DefaultHeaderParts on TopbannerdefaultblockRecord {
    __typename
    id
    mirrorxaxis
    mirroryaxis
    images {
      ...ImageFileParts
    }
    content {
      ...TextBlockParts
    }
  }
  ${ImageFilePartsFragmentDoc}
  ${TextBlockPartsFragmentDoc}
`;
export const TopbannerdefaultblockRecordPartsFragmentDoc = /*#__PURE__*/ gql`
  fragment TopbannerdefaultblockRecordParts on TopbannerdefaultblockRecord {
    __typename
    id
    id
    images {
      ...ImageFileParts
    }
    content {
      ...TextBlockParts
    }
    mirrorxaxis
    mirroryaxis
  }
  ${ImageFilePartsFragmentDoc}
  ${TextBlockPartsFragmentDoc}
`;
export const IconbBlockRecordPartsFragmentDoc = /*#__PURE__*/ gql`
  fragment IconbBlockRecordParts on IconblockRecord {
    __typename
    id
    icon
  }
`;
export const SeoFieldPartsFragmentDoc = /*#__PURE__*/ gql`
  fragment SeoFieldParts on SeoField {
    __typename
    title
    image {
      ...ImageFileParts
    }
    description
  }
  ${ImageFilePartsFragmentDoc}
`;
export const AuthorblockRecorddPartsFragmentDoc = /*#__PURE__*/ gql`
  fragment AuthorblockRecorddParts on AuthorblockRecord {
    __typename
    id
    author
    date
  }
`;
export const ImageBlockPartsFragmentDoc = /*#__PURE__*/ gql`
  fragment ImageBlockParts on ImageblockRecord {
    __typename
    id
    content {
      ...ImageFileParts
    }
  }
  ${ImageFilePartsFragmentDoc}
`;
export const Contentsection1RecordPartsFragmentDoc = /*#__PURE__*/ gql`
  fragment Contentsection1RecordParts on Contentsection1Record {
    __typename
    id
    image {
      ...ImageBlockParts
    }
    mirrory
    text {
      ...TextBlockParts
    }
  }
  ${ImageBlockPartsFragmentDoc}
  ${TextBlockPartsFragmentDoc}
`;
export const Contentsection2RecordPartsFragmentDoc = /*#__PURE__*/ gql`
  fragment Contentsection2RecordParts on Contentsection2Record {
    __typename
    id
    images {
      ...ImageBlockParts
    }
    primaryimage {
      ...ImageBlockParts
    }
    text {
      ...TextBlockParts
    }
  }
  ${ImageBlockPartsFragmentDoc}
  ${TextBlockPartsFragmentDoc}
`;
export const Contentsection3RecordPartsFragmentDoc = /*#__PURE__*/ gql`
  fragment Contentsection3RecordParts on Contentsection3Record {
    __typename
    id
    mirrory
    images {
      ...ImageBlockParts
    }
    text {
      ...TextBlockParts
    }
  }
  ${ImageBlockPartsFragmentDoc}
  ${TextBlockPartsFragmentDoc}
`;
export const ActionButtonPartsFragmentDoc = /*#__PURE__*/ gql`
  fragment ActionButtonParts on ImageactionbuttonRecord {
    __typename
    id
    url
    content {
      ...ImageFileParts
    }
  }
  ${ImageFilePartsFragmentDoc}
`;
export const ImageBlockPartsWithTitleFragmentDoc = /*#__PURE__*/ gql`
  fragment ImageBlockPartsWithTitle on ImageblockwithtitleRecord {
    __typename
    id
    content {
      ...ImageFileParts
    }
  }
  ${ImageFilePartsFragmentDoc}
`;
export const BulletContainerblockPartsFragmentDoc = /*#__PURE__*/ gql`
  fragment BulletContainerblockParts on BulletcontainerblockRecord {
    id
    __typename
    intro {
      ...TextBlockParts
    }
    title
    content {
      text
      id
    }
  }
  ${TextBlockPartsFragmentDoc}
`;
export const Contentsection4RecordPartsFragmentDoc = /*#__PURE__*/ gql`
  fragment Contentsection4RecordParts on Contentsection4Record {
    __typename
    id
    mirrory
    images {
      ... on ImageactionbuttonRecord {
        ...ActionButtonParts
      }
      ... on ImageblockwithtitleRecord {
        ...ImageBlockPartsWithTitle
      }
    }
    primaryimages {
      ...ImageBlockParts
    }
    bullettext {
      ...BulletContainerblockParts
    }
  }
  ${ActionButtonPartsFragmentDoc}
  ${ImageBlockPartsWithTitleFragmentDoc}
  ${ImageBlockPartsFragmentDoc}
  ${BulletContainerblockPartsFragmentDoc}
`;
export const ListitemblockModelTextFieldPartsFragmentDoc = /*#__PURE__*/ gql`
  fragment ListitemblockModelTextFieldParts on ListitemblockModelTextField {
    blocks
    links
    value
  }
`;
export const ListitemblockRecordPartsFragmentDoc = /*#__PURE__*/ gql`
  fragment ListitemblockRecordParts on ListitemblockRecord {
    __typename
    id
    icon
    mirrorx
    text {
      ...ListitemblockModelTextFieldParts
    }
    title
  }
  ${ListitemblockModelTextFieldPartsFragmentDoc}
`;
export const ListcontainerblockRecordPartsFragmentDoc = /*#__PURE__*/ gql`
  fragment ListcontainerblockRecordParts on ListcontainerblockRecord {
    __typename
    id
    content {
      ...ListitemblockRecordParts
    }
  }
  ${ListitemblockRecordPartsFragmentDoc}
`;
export const Contentsection5RecordPartsFragmentDoc = /*#__PURE__*/ gql`
  fragment Contentsection5RecordParts on Contentsection5Record {
    __typename
    id
    mirrory
    primaryimage {
      ...ImageBlockParts
    }
    content {
      ...ListcontainerblockRecordParts
    }
    text {
      ...TextBlockParts
    }
  }
  ${ImageBlockPartsFragmentDoc}
  ${ListcontainerblockRecordPartsFragmentDoc}
  ${TextBlockPartsFragmentDoc}
`;
export const Contentsection6RecordPartsFragmentDoc = /*#__PURE__*/ gql`
  fragment Contentsection6RecordParts on Contentsection6Record {
    __typename
    id
    mirrorx
    image {
      ...ImageBlockParts
    }
    text {
      ...TextBlockParts
    }
  }
  ${ImageBlockPartsFragmentDoc}
  ${TextBlockPartsFragmentDoc}
`;
export const Contentsection7RecordPartsFragmentDoc = /*#__PURE__*/ gql`
  fragment Contentsection7RecordParts on Contentsection7Record {
    __typename
    id
    primaryimages {
      ...ImageBlockParts
    }
    images {
      ...ActionButtonParts
    }
    text {
      ...TextBlockParts
    }
    mirrory
  }
  ${ImageBlockPartsFragmentDoc}
  ${ActionButtonPartsFragmentDoc}
  ${TextBlockPartsFragmentDoc}
`;
export const Contentsection8RecordPartsFragmentDoc = /*#__PURE__*/ gql`
  fragment Contentsection8RecordParts on Contentsection8Record {
    __typename
    id
    mirrory
    images {
      ...ImageBlockPartsWithTitle
    }
    primaryimages {
      ...ImageBlockParts
    }
    text {
      ...TextBlockParts
    }
  }
  ${ImageBlockPartsWithTitleFragmentDoc}
  ${ImageBlockPartsFragmentDoc}
  ${TextBlockPartsFragmentDoc}
`;
export const Contentsection9RecordPartsFragmentDoc = /*#__PURE__*/ gql`
  fragment Contentsection9RecordParts on Contentsection9Record {
    __typename
    id
    primaryimages {
      ...ImageBlockParts
    }
    images {
      ...ActionButtonParts
    }
    text {
      ...TextBlockParts
    }
    mirrory
  }
  ${ImageBlockPartsFragmentDoc}
  ${ActionButtonPartsFragmentDoc}
  ${TextBlockPartsFragmentDoc}
`;
export const ContentsectionFilesPartsFragmentDoc = /*#__PURE__*/ gql`
  fragment ContentsectionFilesParts on FiledownloadsectionRecord {
    __typename
    id
    fileDownloadTab {
      __typename
      id
      title
      icon {
        ...IconbBlockRecordParts
      }
      files {
        __typename
        id
        filename
        mimeType
        title
        url
      }
    }
  }
  ${IconbBlockRecordPartsFragmentDoc}
`;
export const ContentsectionProductSliderPartsFragmentDoc = /*#__PURE__*/ gql`
  fragment ContentsectionProductSliderParts on ProductslidersectionRecord {
    __typename
    id
    paragraph {
      blocks
      links
      value
    }
    heading
    headingUnderlineColor
    products {
      id
      saleorProducts {
        saleorProduct
        id
      }
    }
  }
`;
export const ImageTilesBlockRecordPartsFragmentDoc = /*#__PURE__*/ gql`
  fragment ImageTilesBlockRecordParts on ImageTilesBlockRecord {
    __typename
    id
    image {
      ...ImageBlockParts
    }
  }
  ${ImageBlockPartsFragmentDoc}
`;
export const HtmlBlockRecordPartsFragmentDoc = /*#__PURE__*/ gql`
  fragment HtmlBlockRecordParts on HtmlBlockRecord {
    __typename
    id
    html
  }
`;
export const PhotoGalleryBlockRecordPartsFragmentDoc = /*#__PURE__*/ gql`
  fragment PhotoGalleryBlockRecordParts on PhotoGalleryBlockRecord {
    __typename
    id
    image {
      ...ImageBlockParts
    }
  }
  ${ImageBlockPartsFragmentDoc}
`;
export const PagePartsFragmentDoc = /*#__PURE__*/ gql`
  fragment PageParts on PageRecord {
    __typename
    id
    parentpage
    parentPage {
      id
    }
    title
    slug
    top {
      ... on TopbannerdefaultblockRecord {
        ...TopbannerdefaultblockRecordParts
      }
    }
    tags {
      ...IconbBlockRecordParts
    }
    seo {
      ...SeoFieldParts
    }
    author {
      ...AuthorblockRecorddParts
    }
    content {
      ... on Contentsection1Record {
        ...Contentsection1RecordParts
      }
      ... on Contentsection2Record {
        ...Contentsection2RecordParts
      }
      ... on Contentsection3Record {
        ...Contentsection3RecordParts
      }
      ... on Contentsection4Record {
        ...Contentsection4RecordParts
      }
      ... on Contentsection5Record {
        ...Contentsection5RecordParts
      }
      ... on Contentsection6Record {
        ...Contentsection6RecordParts
      }
      ... on Contentsection7Record {
        ...Contentsection7RecordParts
      }
      ... on Contentsection8Record {
        ...Contentsection8RecordParts
      }
      ... on Contentsection9Record {
        ...Contentsection9RecordParts
      }
      ... on FiledownloadsectionRecord {
        ...ContentsectionFilesParts
      }
      ... on ProductslidersectionRecord {
        ...ContentsectionProductSliderParts
      }
      ... on ImageTilesBlockRecord {
        ...ImageTilesBlockRecordParts
      }
      ... on PhotoGalleryBlockRecord {
        ...PhotoGalleryBlockRecordParts
      }
      ... on SimplybookmeBlockRecord {
        __typename
        id
      }
      ... on HtmlBlockRecord {
        __typename
        id
        html
      }
    }
  }
  ${TopbannerdefaultblockRecordPartsFragmentDoc}
  ${IconbBlockRecordPartsFragmentDoc}
  ${SeoFieldPartsFragmentDoc}
  ${AuthorblockRecorddPartsFragmentDoc}
  ${Contentsection1RecordPartsFragmentDoc}
  ${Contentsection2RecordPartsFragmentDoc}
  ${Contentsection3RecordPartsFragmentDoc}
  ${Contentsection4RecordPartsFragmentDoc}
  ${Contentsection5RecordPartsFragmentDoc}
  ${Contentsection6RecordPartsFragmentDoc}
  ${Contentsection7RecordPartsFragmentDoc}
  ${Contentsection8RecordPartsFragmentDoc}
  ${Contentsection9RecordPartsFragmentDoc}
  ${ContentsectionFilesPartsFragmentDoc}
  ${ContentsectionProductSliderPartsFragmentDoc}
  ${ImageTilesBlockRecordPartsFragmentDoc}
  ${PhotoGalleryBlockRecordPartsFragmentDoc}
  ${HtmlBlockRecordPartsFragmentDoc}
`;
export const FrontPageHeaderPartsFragmentDoc = /*#__PURE__*/ gql`
  fragment FrontPageHeaderParts on TopBannerFrontPageRecord {
    __typename
    id
    title
    image {
      ...ImageFileParts
    }
  }
  ${ImageFilePartsFragmentDoc}
`;
export const FrontpagePartsFragmentDoc = /*#__PURE__*/ gql`
  fragment FrontpageParts on FrontpageRecord {
    __typename
    id
    top {
      ...FrontPageHeaderParts
    }
    seo {
      ...SeoFieldParts
    }
    content {
      ... on Contentsection1Record {
        ...Contentsection1RecordParts
      }
      ... on Contentsection2Record {
        ...Contentsection2RecordParts
      }
      ... on Contentsection3Record {
        ...Contentsection3RecordParts
      }
      ... on Contentsection4Record {
        ...Contentsection4RecordParts
      }
      ... on Contentsection5Record {
        ...Contentsection5RecordParts
      }
      ... on Contentsection6Record {
        ...Contentsection6RecordParts
      }
      ... on Contentsection7Record {
        ...Contentsection7RecordParts
      }
      ... on Contentsection8Record {
        ...Contentsection8RecordParts
      }
      ... on Contentsection9Record {
        ...Contentsection9RecordParts
      }
      ... on FiledownloadsectionRecord {
        ...ContentsectionFilesParts
      }
      ... on ProductslidersectionRecord {
        ...ContentsectionProductSliderParts
      }
      ... on ImageTilesBlockRecord {
        ...ImageTilesBlockRecordParts
      }
      ... on PhotoGalleryBlockRecord {
        ...PhotoGalleryBlockRecordParts
      }
      ... on SimplybookmeBlockRecord {
        __typename
        id
      }
      ... on HtmlBlockRecord {
        __typename
        id
        html
      }
    }
    published
  }
  ${FrontPageHeaderPartsFragmentDoc}
  ${SeoFieldPartsFragmentDoc}
  ${Contentsection1RecordPartsFragmentDoc}
  ${Contentsection2RecordPartsFragmentDoc}
  ${Contentsection3RecordPartsFragmentDoc}
  ${Contentsection4RecordPartsFragmentDoc}
  ${Contentsection5RecordPartsFragmentDoc}
  ${Contentsection6RecordPartsFragmentDoc}
  ${Contentsection7RecordPartsFragmentDoc}
  ${Contentsection8RecordPartsFragmentDoc}
  ${Contentsection9RecordPartsFragmentDoc}
  ${ContentsectionFilesPartsFragmentDoc}
  ${ContentsectionProductSliderPartsFragmentDoc}
  ${ImageTilesBlockRecordPartsFragmentDoc}
  ${PhotoGalleryBlockRecordPartsFragmentDoc}
  ${HtmlBlockRecordPartsFragmentDoc}
`;
export const StringRecordFragmentFragmentDoc = /*#__PURE__*/ gql`
  fragment StringRecordFragment on StringRecord {
    key
    string {
      alertType
      message
    }
  }
`;
export const PageByParentPageAndSlugDocument = /*#__PURE__*/ gql`
  query PageByParentPageAndSlug($parentpage: ItemId!, $slug: String!) {
    allPages(filter: { parentPage: { eq: $parentpage }, slug: { eq: $slug } }) {
      ...PageParts
    }
  }
  ${PagePartsFragmentDoc}
`;
export const PageBySlugDocument = /*#__PURE__*/ gql`
  query PageBySlug($slug: String!) {
    allPages(filter: { slug: { eq: $slug } }) {
      ...PageParts
    }
  }
  ${PagePartsFragmentDoc}
`;
export const PagesByParentDocument = /*#__PURE__*/ gql`
  query PagesByParent($parentpage: ItemId!) {
    allPages(filter: { parentPage: { eq: $parentpage } }) {
      ...PageParts
    }
  }
  ${PagePartsFragmentDoc}
`;
export const GetFrontPageDocument = /*#__PURE__*/ gql`
  query GetFrontPage($limitDate: DateTime) {
    allFrontpages(filter: { published: { lt: $limitDate } }, first: 1, orderBy: [published_DESC]) {
      ...FrontpageParts
    }
  }
  ${FrontpagePartsFragmentDoc}
`;
export const GetFrontPageBySlugDocument = /*#__PURE__*/ gql`
  query GetFrontPageBySlug($slug: String!) {
    allFrontpages(filter: { slug: { eq: $slug } }, first: 1, orderBy: [published_DESC]) {
      ...FrontpageParts
    }
  }
  ${FrontpagePartsFragmentDoc}
`;
export const GetStringByKeyDocument = /*#__PURE__*/ gql`
  query GetStringByKey($key: String!) {
    allStrings(filter: { key: { eq: $key } }) {
      ...StringRecordFragment
    }
  }
  ${StringRecordFragmentFragmentDoc}
`;

export type SdkFunctionWrapper = <T>(
  action: (requestHeaders?: Record<string, string>) => Promise<T>,
  operationName: string,
  operationType?: string,
) => Promise<T>;
